import { Component, OnInit, ElementRef, EventEmitter, HostListener, Output, Renderer2, AfterViewInit } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { LeftSportsMenuDialog } from '@app/dialogs/left-sport-menu.dialog';
import { UserHelper } from '@helpers/user.helper';
import { LoadingDialog } from '@app/dialogs/loading.dialog';
import { DataHelper } from '@helpers/data.helper';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { timer, Observable, Subject, interval } from 'rxjs';
import { takeUntil, tap, filter, throttleTime, debounceTime } from 'rxjs/operators';
import { EnableCookieConsent, environment, setCookie } from '@environments/environment';
import { TranslateService } from '@services/translate.service';
import { LoadingTicketDialog } from '@app/dialogs/loading-ticket.dialog';
import { ConsentScreenDialog } from '@components/consent-screen-dialog.component';
import { sideBannerItemType } from '@components/slider/sideBanner/side-banner-slider.model';
import { LiveStreamService } from '@services/liveStream.service';
import { DimmerService } from '@services/dimmer.service';

@Component({
  selector: 'app-root',
  templateUrl: '../sharedTemplates/core.component.html',
})
export class CoreComponent implements OnInit, AfterViewInit {
  public isBetSlipRoute: string[] = ['casino', 'promotions', 'account', 'register'];
  private isLeftMenuRoute: string[] = ['', 'favorites', 'home', 'sports', 'search', 'allevents', 'eventdetail', 'league', 'em-tippspiel-de', 'em-tippspiel-en', 'outright'];
  constructor(
    public _UiHelper: UiHelper,
    private _ApiService: ApiService,
    public _MatDialog: MatDialog,
    private _ElementRef: ElementRef,
    private _Renderer2: Renderer2,
    public _UserHelper: UserHelper,
    public _DataHelper: DataHelper,
    private route: ActivatedRoute,
    private _Router: Router,
    private _SignalrServiceLegacy: SignalrServiceLegacy,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    public dialog: MatDialog,
    public _LiveStreamService: LiveStreamService,
    public _DimmerService: DimmerService
  ) {
    this.setThemeStateInit();

    this.cancel = this.state.pipe(
      filter(v => v === 'cancel'),
      tap(v => {
        this.holdTime.emit(0);
        this.holdSeconds = 0;
        this.progressValue = 0;
      })
    );
    this.scrollEventSubject.pipe(throttleTime(100)).subscribe(x => {
      try {
        const topPosition = this.isMobileView ? document.getElementsByClassName('main-page')[0].scrollTop : document.documentElement.scrollTop || document.body.scrollTop;
        this._UiHelper.showScrollToTopButton = topPosition > 300; // YUKSEKLİK_DEĞERİ, menünün görünür olacağı scroll yüksekliği.
      } catch (e) {
        console.error(e);
      }
    });

    this.getAntiForgeryToken();
    this.appTimer();

    this.responsiveResolution(this._UiHelper.windowsWidth);

    this._UiHelper.windowResized.subscribe(x => {
      this.resizeChangeListener.next(x.w);
    });

    this.resizeChangeListener.pipe(debounceTime(1000)).subscribe(width => {
      this.responsiveResolution(width);
    });

    setInterval(() => {
      if (this._UserHelper.isSignedIn != undefined && this._UserHelper.isSignedIn && this._UserHelper.customerUser.CustomerId) {
        this._ApiService.getClient2().then().catch();
      }
    }, 60000);

    this._UiHelper.responsiveResolutionListener.subscribe(x => {
      console.log(x);
    });
    // cashout Initial data check when user signIn
    this._UserHelper.signInListener.subscribe(x => {
      if (x) {
        if (environment.isLiveStream) {
          this._LiveStreamService.tvStreamingTimerAction();
        }

        this._ApiService.getCashoutSlipsExternal(1);
        this._UiHelper.consentScreenDialogListener.emit(true);
        this.favFixtureList();
        document.documentElement.style.setProperty('--isLoggedInDisplay', 'none');
        document.documentElement.style.setProperty('--isLogin', 'flex');

        if (environment.isMyTeam) {
          this._ApiService.getCustomerTeamList();
        }
      } else {
        document.documentElement.style.setProperty('--isLoggedInDisplay', 'flex');
        document.documentElement.style.setProperty('--isLogin', 'none');
      }

      if (!this._UserHelper.isSignedIn) {
        this._UiHelper.loginDropDownIsOpen = true;
      }
    });

    this.getSliderDesktop();
    this.setOddsFormat();

    this.cancel = this.state.pipe(
      filter(v => v === 'cancel'),
      tap(v => {
        // console.log('%c stopped hold ', 'color: red; font-weight: bold');
        this.holdTime.emit(0);
        this.holdSeconds = 0;
        this.progressValue = 0;
      })
    );
  }
  private openBirthdayModal() {
    const storageIsBirthday = localStorage.getItem('isBirthdayModal');
    const birthDateData = this._UserHelper.customerUser?.BirthDay;
    const isFreeBetBonus = this._DataHelper.selectedWallet?.IsFreeBetBonus;
    if (
      environment.birthdateBonusModal &&
      isFreeBetBonus &&
      this._UserHelper.customerUser.IsLimitSet &&
      this._UserHelper.customerUser.IsInsic &&
      this._UserHelper.customerUser.IsContractAccepted &&
      storageIsBirthday !== 'true' &&
      this.isTodayBirthday(birthDateData)
    ) {
      this._UiHelper.dimmerListener.emit({
        status: 'open',
        modalId: 'birthdateBonus',
      });
      localStorage.setItem('isBirthdayModal', 'true');
    }
  }

  private isTodayBirthday(birthDayData: any): boolean {
    if (birthDayData) {
      const birthDayTimestamp = parseInt(birthDayData.match(/\d+/)[0], 10);

      const birthDate = new Date(birthDayTimestamp);

      const today = new Date();

      const isBirthdayToday = birthDate.getDate() === today.getDate() && birthDate.getMonth() === today.getMonth();

      return isBirthdayToday;
    } else return false;
  }

  setOddsFormat() {
    this._UiHelper.oddsFormatTypeData = [
      { id: 1, name: this._TranslateService.instant('odds_type_format_1') },
      { id: 2, name: this._TranslateService.instant('odds_type_format_2') },
      { id: 3, name: this._TranslateService.instant('odds_type_format_3') },
      { id: 4, name: this._TranslateService.instant('odds_type_format_4') },
    ];
    if (Number(localStorage.getItem('oddFormatId'))) {
      // Seçili Format
      this._UiHelper.selectedFormatType(Number(localStorage.getItem('oddFormatId')));
    } else {
      //Decimal Format
      this._UiHelper.selectedFormatType(1);
    }
  }

  setThemeStateInit() {
    if (localStorage.getItem('themeState')) {
      const bodyElement = document.getElementsByTagName('body');
      this._UiHelper.currentTheme = localStorage.getItem('themeState');
      if (bodyElement && bodyElement.length > 0) {
        bodyElement[0].classList.add(localStorage.getItem('themeState'));
      }
    } else {
      const bodyElement = document.getElementsByTagName('body');
      localStorage.setItem('themeState', 'theme-light');
      this._UiHelper.currentTheme = 'theme-light';
      if (bodyElement && bodyElement.length > 0) {
        bodyElement[0].classList.add('theme-light');
      }
    }
  }
  isOpenLeagueMenu = true;
  isOpenSportsMenu = true;
  quickTippIsActive = false;
  isMobileView = false;

  leftMenu = false;
  rightMenu = false;
  loadingDialogBlur = false;
  navbar_titleTranslate = '';
  navbar_title = '';
  navbar_showed = false;
  scrollEventSubject = new Subject();
  _contentMarginTop = 0;

  constentShow;
  history = [];

  holdSeconds = 0;
  progressValue = 0;
  accountLockIsDisabled = false;
  private loadingDialogRef: MatDialogRef<LoadingDialog>;

  @Output() holdTime: EventEmitter<number> = new EventEmitter<number>();
  state: Subject<string> = new Subject<string>();
  cancel: Observable<string>;

  _flagCashoutInitial = false;

  resizeChangeListener = new Subject();

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    this._UiHelper.setDocumentScrollPX(document.documentElement.scrollTop);
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event) {
    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);
  }

  @HostListener('window:resize', ['$event'])
  onResizeBrowser(event) {
    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);
  }

  @HostListener('mouseup', ['$event'])
  @HostListener('mouseleave', ['$event'])
  onExit() {
    this.state.next('cancel');
  }

  @HostListener('mousedown', ['$event'])
  onHold(e) {
    const target = e.target || e.srcElement || e.currentTarget;
    const idAttr = target.attributes.id;
    if (idAttr == undefined) {
      return '';
    }

    const value = idAttr.nodeValue;
    if (value != 'accountLockButton24') {
      return '';
    }

    this.state.next('start');

    const n = 100;
    interval(n)
      .pipe(
        takeUntil(this.cancel),
        tap(v => {
          const result = v * n;
          this.holdSeconds = result / 1000;
          this.progressValue = (this.holdSeconds / 3) * 100;
          if (result == 3000) {
            this.state.next('cancel');

            this._ApiService.accountLock24().then(result => {
              if (result.code == '') {
                return 'error|System Error';
              } else {
                if (result.code == 'error') {
                  this._UiHelper.errorSnackBar(result.message, '');
                } else if (result.code == 'errorcode') {
                  const t_message = this._TranslateService.instant(result.message);
                  this._UiHelper.errorSnackBar(t_message, '');
                } else if (result.code == 'success') {
                  this._UiHelper.successSnackBar(result.message, '');
                  this.holdSeconds = 0;
                  this.progressValue = 0;
                  this.accountLockIsDisabled = true;
                }
              }
            });
          }

          this.holdTime.emit(result);
        })
      )
      .subscribe();
  }

  getAntiForgeryToken() {
    const element = this._Renderer2.selectRootElement('#cont_antiforgerytoken input');
    this._ApiService.setAntiForgeryToken(element.value);
  }

  leftSportMenuDialogOpener(x) {
    const dialogRef = this._MatDialog;
    if (x) {
      dialogRef
        .open(LeftSportsMenuDialog, {
          width: '350px',
          minHeight: '35vh',
          panelClass: 'left-sports-menu-dialog',
        })
        .afterClosed()
        .subscribe();
    } else {
      dialogRef.closeAll();
    }
  }

  loadingDialogOpener(x) {
    if (x) {
      if (!this._MatDialog.getDialogById('loadingD')) {
        this.loadingDialogRef = this._MatDialog.open(LoadingDialog, {
          id: 'loadingD',
          width: '350px',
          minHeight: '35vh',
          panelClass: 'loadingDialog',
          disableClose: true,
          closeOnNavigation: true,
        });

        this.loadingDialogRef.afterClosed().subscribe(result => {
          this._UiHelper.setLoadingDialog(false);
        });
        this.loadingDialogBlur = true;
      } else {
        this.loadingDialogBlur = false;
        // closeall maybe cause side effect
      }
    }
  }

  loadingTicketDialogOpener(x) {
    const dialogRef = this._MatDialog;
    if (x) {
      dialogRef
        .open(LoadingTicketDialog, {
          width: '250px',
          minHeight: '100px',
          panelClass: 'loadingTicketDialog',
          disableClose: true,
          closeOnNavigation: true,
        })
        .afterClosed()
        .subscribe(result => {
          this._UiHelper.setLoadingDialog(false);
        });
      this.loadingDialogBlur = true;
    } else {
      this.loadingDialogBlur = false;
      // closeall maybe cause side effect
    }
  }

  setContentMarginTop(x) {
    this._contentMarginTop = x;
  }

  refreshAPP() {
    window.location.href = '/home';
  }

  ngOnInit() {
    this._Router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.url.split('/');
        if (url && url.length > 0) {
          const route = url[1] === '' ? '' : url[1].match(/^(\w[\w-]*)/)[0];
          if (!this.isBetSlipRoute.includes(route)) {
            this._UiHelper.isBetSlip = true;
          } else {
            this._UiHelper.isBetSlip = false;
          }
          if (this.isLeftMenuRoute.includes(route)) {
            this._UiHelper.isLeftMenu = true;
          } else {
            this._UiHelper.isLeftMenu = false;
          }
        }
      }
    });
    this._DataHelper.getStorageBookBets();
    this._ApiService.getSideBanner().then((x: sideBannerItemType[]) => {
      this._DataHelper.sliderList = x;
    });
    if (EnableCookieConsent) {
      if (localStorage.getItem('_C')) {
        this.constentShow = localStorage.getItem('_C');
      } else {
        this.constentShow = '1';
      }
    }

    document.addEventListener('visibilitychange', e => {
      if (document.visibilityState === 'visible') {
        this._UiHelper.setIsTabActive(true, e.timeStamp);
      } else if (document.visibilityState === 'hidden') {
        this._UiHelper.setIsTabActive(false, e.timeStamp);
      }
    });

    this._UiHelper.isTabActiveListener.subscribe((x: any) => {
      return;
    });

    this._DataHelper.favListListener.subscribe(() => {
      if (Array.isArray(this._DataHelper.favList) && this._DataHelper.favList.length > 0) {
        this.favFixtureList();
      }
    });
    this._DataHelper.liveDataListener.subscribe(x => {
      if (x && x.length > 0) {
        this.favoriteLiveListener(x);
        this._LiveStreamService.setLiveData(x);
      }
    });
  }

  favoriteLiveListener(x) {
    let favDisabled = [...this._DataHelper.favDisabledMatchId];
    let favList = [...this._DataHelper.favList];
    if (this._DataHelper.favDisabledMatchId.length > 0) {
      this._DataHelper.favDisabledMatchId.forEach((i: any) => {
        if (!x.some((item: any) => item.BetradarMatchId === i)) {
          favDisabled = favDisabled.filter(disabledItem => disabledItem !== i);
          favList = favList.filter(favItem => favItem !== i);
        }
      });

      if (favDisabled.length !== this._DataHelper.favDisabledMatchId.length) {
        this._DataHelper.favList = favList;
        this._DataHelper.favListListener.emit();
        localStorage.setItem('favList', JSON.stringify(favList));
        this._DataHelper.favDisabledMatchId = favDisabled;
      }
    }
  }

  favFixtureList(): void {
    this._ApiService.getFavFixture(this._DataHelper.favList).then(data => {
      this._DataHelper.setFavFixtureData(data);
    });
  }

  private readonly INACTIVE_TIME = environment.idleTime;

  private lastInteractionTime: number;

  @HostListener('window:mousemove')
  @HostListener('window:click')
  onInteraction() {
    this.lastInteractionTime = Date.now();
  }
  @HostListener('window:mousemove', ['$event'])
  @HostListener('window:keypress', ['$event'])
  @HostListener('window:touchstart', ['$event'])
  constentForm() {
    localStorage.setItem('_C', '0');
    this.constentShow = '0';
  }

  ngAfterViewInit() {
    this._ApiService
      .getSlider('2')
      .then(x => {
        let slider_Data;
        slider_Data = x.filter(element => {
          return new Date() <= new Date(Number(element.EndDate.replace(/\D/g, ''))) && new Date() >= new Date(Number(element.StartDate.replace(/\D/g, '')));
        });
        this._DataHelper.setHomeSliderData(x);
      })
      .catch(err => console.log('core', err));

    this._DataHelper.numberOfBetsListener.subscribe(x => {
      const q = JSON.parse(localStorage.getItem('quickTipp'));
      if ((x === 0 || x === 1) && q) {
        this.quickTippIsActive = true;
      } else if (x >= 2) {
        this.quickTippIsActive = false;
      }
    });

    this._ApiService.getTopWinner().then();
    this._UiHelper.leftMenuListener.subscribe(x => (this.leftMenu = x));
    this._UiHelper.rightMenuListener.subscribe(x => (this.rightMenu = x));

    this._UiHelper.leftSportsMenuDialogListener.subscribe(x => this.leftSportMenuDialogOpener(x));
    this._UiHelper.loadingDialogListener.subscribe(x => this.loadingDialogOpener(x));
    this._UiHelper.loadingTicketDialogListener.subscribe(x => this.loadingTicketDialogOpener(x));

    this._UiHelper.consentScreenDialogListener.subscribe(x => this.openConsentScreenDialog());
    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);
    this._UiHelper.contentMarginTopListener.subscribe(x => {
      this.setContentMarginTop(x);
    });
    this._UiHelper.navbarTitleListener.subscribe(x => {
      if (x.isRaw) {
        this.navbar_title = x.s;
        this.navbar_titleTranslate = '';
      } else {
        this.navbar_title = '';
        this.navbar_titleTranslate = x.s;
      }
      this.navbar_showed = x.show;
    });
    this._UiHelper.refreshAppListener.subscribe(x => {
      this.refreshAPP();
    });

    this._UiHelper.setNavbarTitle('', false, false);

    this._ApiService
      .getClient()
      .then(result => {
        this._UserHelper.setUser(result);

        if (this._UserHelper.isSignedIn) {
          if (this._UserHelper.customerUser != undefined && this._UserHelper.customerUser.CustomerId != undefined) {
            this._ApiService.getWalletList().then(result => {
              // this._UserHelper.walletList=result;
              this._UserHelper.setWalletList(result);
              this.openBirthdayModal();
            });
          }
        }
      })
      .catch();
    // }

    // Sports Filter Control
    this._DataHelper.LeagueDataListener.subscribe(x => {
      this._Router.navigate(['/sports']);
    });
    this._ApiService.getCurrentSlip();

    this.getTaxRate();

    this._ApiService.getCountryInfo().catch();

    this._UiHelper.loadingDialogListener.subscribe(x => {
      if (!x && this._MatDialog.getDialogById('loadingD')) {
        // this.loadingDialogRef.close();
        this._MatDialog.getDialogById('loadingD').close();
      }
    });

    try {
      document.getElementsByClassName('main-page')[0].addEventListener('scroll', () => {
        this.scrollEventSubject.next();
      });
    } catch (e) {
      console.error(e);
    }
  }

  getTaxRate() {
    this._ApiService.getTaxRate().then(result => {
      this._DataHelper.setTaxRate(result);
    });
  }

  appTimer() {
    const source = timer(20000, 60000);
    const abc = source.subscribe(val => {
      // Token Updater
      this.getAntiForgeryToken();
      // Balance Updater
      if (this._UserHelper.isSignedIn && this._UserHelper.customerUser.CustomerId) {
        this._ApiService
          .getClient2()
          .then(result => {
            if (!this._flagCashoutInitial) {
              if (this._UserHelper.isSignedIn) {
                if (this._UserHelper.customerUser != undefined && this._UserHelper.customerUser.CustomerId != undefined) {
                  // this._ApiService.getWalletList().then((result) => {
                  //   this._UserHelper.setWalletList(result);
                  // });

                  this._flagCashoutInitial = true;
                }
              }
            }
          })
          .catch();
      }
    });
  }
  signOut() {
    this._ApiService
      .signOut()
      .then(result => {
        this._UserHelper.userLogOut();

        this.refreshAPP();
      })
      .catch(err => console.log('idle.dialog', err));
  }

  closeQuickTippOutput(e) {
    this.quickTippIsActive = false;
  }

  responsiveResolution(width) {
    if (width <= 990) {
      this._UiHelper.setResponsiveResolution('xs');
    } else if (width > 990 && width <= 1150) {
      this._UiHelper.setResponsiveResolution('xs');
      // this._UiHelper.setResponsiveResolution('m');
    } else if (width > 1150 && width <= 1370) {
      this._UiHelper.setResponsiveResolution('l');
    } else if (width > 1370 && width <= 1640) {
      this._UiHelper.setResponsiveResolution('xl');
    } else {
      this._UiHelper.setResponsiveResolution('xxl');
    }

    if (width <= 990) {
      this.isMobileView = true;
    } else if (width > 990) {
      this.isMobileView = false;
    }
  }
  consentScreenRef: any;
  openConsentScreenDialog(): void {
    if (this.consentScreenRef && this.consentScreenRef.getState() === MatDialogState.OPEN) {
      return;
    }
    if (!this._UserHelper?.customerUser.IsContractAccepted) {
      this.consentScreenRef = this.dialog.open(ConsentScreenDialog, {
        width: '610px',
        panelClass: 'transcationDialog-center',
        disableClose: true,
        height: '400px',
      });
    }
  }

  @HostListener('window:scroll', ['$event'])
  onPageScroll() {
    this.scrollEventSubject.next();
  }
  getSliderDesktop() {
    this._ApiService
      .getSliderWeb('2')
      .then(x => {
        if (x && x.length > 0) {
          this._UiHelper.sliderWebData = x;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  deleteCookie(cname: string) {
    document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }
  firstSetCookie() {
    this.route.queryParams.subscribe(params => {
      if (params != undefined) {
        if (params.ia_affid || params.btag || params.siteid) {
          this.deleteCookie('IACokiees');
          localStorage.setItem(
            'IACokiees',
            JSON.stringify({
              ia_affid: params.ia_affid,
              btag: params.btag,
              siteid: params.siteid,
              playerid: params.playerid,
              timeStamp: new Date().getTime(),
            })
          );
          const ObjAffilation = {
            btag: params.btag,
            ia_affid: params.ia_affid,
            siteId: params.siteid,
            timeStamp: new Date().getTime(),
          };
          const ObjAffilation2 = JSON.stringify(ObjAffilation);
          setCookie('IACokiees', ObjAffilation2, 30);
        }
      }
    });
  }
}
